import { type FC } from "react";
import { useView } from "use-pouchdb";
import { Link } from "react-router";
import * as uuid from "uuid";

import { assertIsItemInfo } from "../../common/schema";
import { ItemItem } from "../ItemItem";

export const TemplateList: FC = () => {
  const { rows, state, error } = useView("built/not_deleted", { include_docs: true, limit: 500 });
  if (state === "error") return <p>Error: {`${error}`}</p>;
  const newId = `item:${uuid.v7()}`;
  return <div style={{display: "flex", flexDirection: "column"}}>
    <h3 style={{marginLeft: "3px"}}>Templates</h3>
    <div style={{marginLeft: "3px", marginBottom: "4px"}}>
      <Link to={`/items/${newId}?is_template=1`}>New template</Link>
    </div>
    {rows.filter(row => {
      assertIsItemInfo(row.doc);
      return row.doc.is_template === true;
    }).map(row => {
      assertIsItemInfo(row.doc);
      return <ItemItem key={row.doc._id} doc={row.doc} />;
    })}
  </div>;
};
